<template>
  <nav class="navbar">
    <div class="navbar-container">
      <router-link to="/" class="navbar-logo" @click="rotateLogo">
        <span>Сайт учителя математики</span>
        <svg
            class="logo-shape"
            :class="{ 'rotate': isLogoRotating }"
            viewBox="0 0 100 100"
            width="40"
            height="40"
        >
          <path d="M50 10 L90 90 L10 90 Z" fill="rgba(100, 150, 255, 0.3)"/>
        </svg>
      </router-link>
      <button
          class="navbar-toggle"
          :class="{ 'active': isMenuOpen }"
          @click.stop="toggleMenu"
      >
        <span class="navbar-toggle-icon"></span>
      </button>
      <ul
          :class="['navbar-menu', { 'active': isMenuOpen }]"
          @click.stop
      >
        <li><router-link to="/" class="navbar-link" @click="handleLinkClick">Главная</router-link></li>
        <li><router-link to="/about" class="navbar-link" @click="handleLinkClick">О себе</router-link></li>
        <li><router-link to="/materials" class="navbar-link" @click="handleLinkClick">Материалы</router-link></li>
        <li><router-link to="/contact" class="navbar-link" @click="handleLinkClick">Связь со мной</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TeacherNavbar',
  data() {
    return {
      isMenuOpen: false,
      isLogoRotating: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleClickOutside(event) {
      const menu = this.$el.querySelector('.navbar-menu');
      const toggle = this.$el.querySelector('.navbar-toggle');
      if (!menu || !toggle) return;

      const isClickInside = menu.contains(event.target) || toggle.contains(event.target);

      if (!isClickInside && this.isMenuOpen) {
        this.closeMenu();
      }
    },
    rotateLogo() {
      this.isLogoRotating = true;
      setTimeout(() => {
        this.isLogoRotating = false;
      }, 500);
    },
    handleLinkClick() {
      this.closeMenu();
      this.rotateLogo();
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.navbar {
  background: rgba(255, 255, 255, 0.95);
  padding: 15px 20px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
}

.navbar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.navbar-logo span {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  letter-spacing: 0.5px;
}

.logo-shape {
  opacity: 0.8;
  transition: transform 0.5s ease;
  transform-origin: center;
}

.logo-shape.rotate {
  transform: rotate(360deg);
}

.navbar-logo:hover .logo-shape:not(.rotate) {
  transform: rotate(360deg);
}

.navbar-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  transition: transform 0.3s ease;
  z-index: 1001;
}

.navbar-toggle:hover {
  transform: scale(1.1);
}

.navbar-toggle-icon {
  display: block;
  width: 28px;
  height: 3px;
  background: #333;
  position: relative;
  transition: all 0.3s ease;
}

.navbar-toggle-icon::before,
.navbar-toggle-icon::after {
  content: '';
  width: 100%;
  height: 100%;
  background: #333;
  position: absolute;
  left: 0;
  transition: transform 0.3s ease;
}

.navbar-toggle-icon::before {
  top: -8px;
}

.navbar-toggle-icon::after {
  top: 8px;
}

.navbar-toggle.active .navbar-toggle-icon {
  background: transparent;
}

.navbar-toggle.active .navbar-toggle-icon::before {
  transform: rotate(45deg) translate(5px, 6px);
}

.navbar-toggle.active .navbar-toggle-icon::after {
  transform: rotate(-45deg) translate(5px, -6px);
}

.navbar-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.navbar-link {
  text-decoration: none;
  color: #444;
  font-weight: 600;
  padding: 8px 15px;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 5px;
}

.navbar-link::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: rgba(100, 150, 255, 0.8);
  transition: all 0.3s ease;
}

.navbar-link:hover {
  color: rgba(100, 150, 255, 0.9);
}

.navbar-link:hover::before {
  width: 100%;
  left: 0;
}

.navbar-link.router-link-exact-active {
  color: rgba(100, 150, 255, 1);
  background: rgba(100, 150, 255, 0.1);
}

.navbar-link.router-link-exact-active::before {
  width: 100%;
  left: 0;
  background: rgba(100, 150, 255, 0.5);
}

@media (max-width: 768px) {
  .navbar {
    padding: 10px 15px;
  }

  .navbar-logo span {
    font-size: 20px;
  }

  .navbar-toggle {
    display: block;
  }

  .navbar-menu {
    display: flex;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.98);
    position: fixed;
    top: 65px;
    right: 15px;
    width: 220px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 15px;
    opacity: 0;
    transform: translateY(-20px);
    visibility: hidden;
    transition: all 0.3s ease;
    pointer-events: none;
  }

  .navbar-menu.active {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
    pointer-events: all;
  }

  .navbar-link {
    width: 100%;
    padding: 12px;
    margin: 5px 0;
  }

  .navbar-link.router-link-exact-active {
    background: rgba(100, 150, 255, 0.08);
  }
}
</style>